const Copyright = () => {
    return(
        <>
            <div className='copyright'>
                <p>© Copyright 2020 St. Mary's School & College Mirzapur, Uttar Pradesh. All Rights Reserved. | Created By Entab Infotech : CampusCare® </p>
            </div>
        </>
    )
}
export default Copyright